import React from 'react';
import type {
  PatientGoalDetail,
  PatientInterventionDetail,
} from '../../services/api/types.gen';

// The row's import caveats, shown inside the Imported-chip popover
// so they are visible exactly while the chip is. Interventions carry their
// own findings but no chip, so they list here under the goal's. The
// intervention list is the card's refreshed saved state, so a deleted
// intervention's caveat leaves with the row.
const ImportFindingsList: React.FC<{
  goal: PatientGoalDetail;
  interventions: PatientInterventionDetail[];
}> = ({ goal, interventions }) => {
  const rows = [
    ...(goal.import_findings ?? []).map(finding => ({
      label: null as string | null,
      finding,
    })),
    ...interventions.flatMap(intervention =>
      (intervention.import_findings ?? []).map(finding => ({
        label: intervention.name || 'Intervention',
        finding,
      }))
    ),
  ];
  if (rows.length === 0) return null;
  return (
    <div className='space-y-1'>
      <p className='text-xs font-semibold'>Import caveats</p>
      <ul className='list-disc space-y-1 pl-4 text-xs'>
        {rows.map((row, index) => (
          <li key={index} className='[overflow-wrap:anywhere]'>
            {row.label ? `${row.label}: ` : ''}
            {row.finding.text}
            {row.finding.original && (
              <span className='mt-0.5 block whitespace-pre-wrap text-muted-foreground'>
                External EMR&apos;s text: {row.finding.original}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ImportFindingsList;
